import { formatUnits } from 'viem'

const whole = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })
const short = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 })
const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 })
const usdSmall = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 2 })

export const toWif = (wei: bigint) => Number(formatUnits(wei, 18))

/** 1,234 WIF, or 12.5 for small amounts, so tiny heat never reads as 0. */
export function wif(wei: bigint): string {
  const n = toWif(wei)
  if (n === 0) return '0'
  if (n < 10) return short.format(n) === '0' ? '<0.1' : short.format(n)
  return whole.format(n)
}

export function dollars(wei: bigint, price: number | null): string | null {
  if (price === null) return null
  const v = toWif(wei) * price
  if (v === 0) return '$0'
  return v < 1 ? usdSmall.format(v) : usd.format(v)
}

export const shortAddress = (a: string) => `${a.slice(0, 6)}…${a.slice(-4)}`

export function duration(seconds: number): string {
  const s = Math.max(0, Math.round(seconds))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  if (h > 0) return `${h}h ${m}m`
  if (m > 0) return `${m}m`
  return `${s}s`
}

export function ago(timestamp: number, now: number): string {
  const s = now - timestamp
  if (s < 60) return 'just now'
  if (s < 3600) return `${Math.floor(s / 60)}m ago`
  if (s < 86_400) return `${Math.floor(s / 3600)}h ago`
  return `${Math.floor(s / 86_400)}d ago`
}

export function hostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}

/** Parse what someone typed into an amount field into WIF wei, or null if it isn't a number. */
export function parseWif(input: string): bigint | null {
  const t = input.replace(/,/g, '').trim()
  if (!/^\d+(\.\d{0,18})?$/.test(t)) return null
  const [int, frac = ''] = t.split('.')
  return BigInt(int) * 10n ** 18n + BigInt((frac + '0'.repeat(18)).slice(0, 18))
}
